export default __webpack_public_path__ + "static/media/xmas-slide2-mobile.bf290e92.jpg";